import React from 'react';

const LeftShape = ({ className }) => {
  return (
    <svg
      className={className}
      width="219"
      height="354"
      viewBox="0 0 219 354"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13349 309.276C15.0988 309.965 233.633 254.156 174.253 138.156C136.133 97.1563 99.396 197.656 77.6329 131.156C59.6333 76.1563 53.134 -21.3437 3.13351 44.6563"
        stroke="#30717A"
        strokeWidth="6"
      />
      {/* <path d="M3.13349 309.276C15.0988 309.965 233.633 254.156 174.253 138.156C136.133 97.1563 99.396 197.656 77.6329 131.156C59.6333 76.1563 53.134 -21.3437 3.13351 44.6563" stroke="#30717A" stroke-width="6"/> */}
    </svg>
  );
};

export default LeftShape;
